module.exports = __webpack_public_path__ + "img/title5.dc30f7e0.png";